import { NotificationItem } from ".";

/**
 * What the bell shows until it is connected.
 *
 * The dropdown takes its notifications through props and the shell had none to
 * give, so the badge was blank and the list empty however many unread items the
 * Inbox held. These stand in for them, so the design can be seen and reviewed.
 *
 * TODO(design): needs the user's own notifications — the same source the Inbox
 * reads, or an unread-count endpoint if one exists. Note the shape below is the
 * dropdown's own, not `UserNotification` from hooks/api: whoever connects it
 * maps one onto the other. See DEVELOPER_TASKS.md.
 */
export const PREVIEW_NOTIFICATIONS: NotificationItem[] = [
  {
    id: 1,
    title: "New user registered",
    description: "olena.k@example.com joined a minute ago.",
    read: false,
    date: "2026-09-08 09:41",
  },
  {
    id: 2,
    title: "Campaign sent",
    description: "“The new collection is here” went to 12,480 people.",
    read: false,
    date: "2026-09-08 08:15",
  },
  {
    id: 3,
    title: "Review needs a reply",
    description: "A two-star review was left on the mobile app.",
    read: false,
    date: "2026-09-07 17:02",
  },
  {
    id: 4,
    title: "Password changed",
    description: "Your password was changed from a new device.",
    read: true,
    date: "2026-09-07 11:30",
  },
];
